import { render, staticRenderFns } from "./conversation-modal.vue?vue&type=template&id=0aa5d597"
import script from "./conversation-modal.vue?vue&type=script&lang=js"
export * from "./conversation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConversationsConversationInboxList: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/conversations/ConversationInboxList.vue').default,ConversationsConversationThread: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/conversations/conversation-thread.vue').default,ConversationsNewConversation: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/conversations/newConversation.vue').default})
